import * as Sentry from "@sentry/angular";
import {
  ApplicationConfig,
  provideZoneChangeDetection,
  ErrorHandler,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { routes } from './app.routes';
import { MobileService } from "./shared-module/services/mobile.service";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from "@angular/common/http";
import ModalService from "./shared-module/services/modal.service";
import { AuthService } from "./shared-module/services/auth.service";
import LoaderService from "./shared-module/services/loader.service";
import HttpBaseUrlInterceptor from "./shared-module/interceptors/http-base-url-interceptor.interceptor";
import RelationContactStore from "./shared-module/services/Stores/relation-contact.store";
import HttpErrorInterceptor from "./shared-module/interceptors/http-error-interceptor.interceptor";
import TicketStore from "./shared-module/services/Stores/ticket.store";
import ProductStore from "./shared-module/services/Stores/product.store";
import CallStore from "./shared-module/services/Stores/call.store";
import { LOCALE_ID } from '@angular/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    MobileService,
    ModalService,
    AuthService,
    LoaderService,
    RelationContactStore,
    TicketStore,
    ProductStore,
    CallStore,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: HttpBaseUrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'nl' },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler()
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    })
  ]
};